import React, { useState } from "react";
import axios from "axios";
import { Loader2, ShieldCheck, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// "Check Stripe now" — read-only comparison of uReserve vs Stripe; changes nothing.
export function useStripeCheck() {
  const [checking, setChecking] = useState(false);
  const [result, setResult] = useState(null);
  const run = async () => {
    setChecking(true);
    try {
      const r = await axios.post(`${API}/admin/subscriptions/check`);
      setResult(r.data);
    } catch (e) {
      setResult({ error: e?.response?.data?.detail || e.message });
    } finally {
      setChecking(false);
    }
  };
  return { checking, result, run, clear: () => setResult(null) };
}

export function StripeCheckButton({ checking, onRun, disabled }) {
  return (
    <button
      onClick={onRun}
      disabled={checking || disabled}
      title="Compare every subscription with Stripe and list anything that doesn't match. Changes nothing."
      data-testid="subscriptions-check-btn"
      className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-navy border border-navy px-2.5 py-1 rounded-[3px] hover:bg-navy-wash transition-colors disabled:opacity-50"
    >
      {checking ? <Loader2 size={13} className="animate-spin" /> : <ShieldCheck size={13} />}
      Check Stripe now
    </button>
  );
}

export function StripeCheckResults({ result, onClose }) {
  if (!result) return null;
  const entries = Object.entries(result.problems || {});
  const ok = !result.error && entries.length === 0;
  return (
    <div
      className="mt-3 border rounded-[3px] px-3 py-2 text-[12px] relative"
      style={{ borderColor: ok ? "#1C4E80" : "#EA6A47", background: ok ? "#F2F9FD" : "#FEF5F2" }}
      data-testid="stripe-check-results"
    >
      <button onClick={onClose} className="absolute right-2 top-2 text-slate hover:text-navy" data-testid="stripe-check-close" aria-label="Close">
        <X size={13} />
      </button>
      {result.error ? (
        <div className="text-coral font-semibold">Stripe check failed: {result.error}</div>
      ) : ok ? (
        <div className="text-navy font-semibold" data-testid="stripe-check-ok">
          All Associations that have subscribed are properly linked with Stripe.
        </div>
      ) : (
        <>
          <div className="font-semibold" style={{ color: "#B4331A" }}>
            {entries.length} item{entries.length === 1 ? " needs" : "s need"} attention ({result.checked} checked). Nothing was changed.
          </div>
          {entries.map(([name, items]) => (
            <div key={name} className="mt-1.5" data-testid="stripe-check-problem">
              <div className="font-semibold text-navy">{name}</div>
              <ul className="list-disc ml-5 text-ink">
                {items.map((i) => <li key={i}>{i}</li>)}
              </ul>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
